<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.11</b> - Исправления ошибок и улучшения</p>
    <div class="ml-5 pb-4 text-pink-400">
      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>
          Исправлено отображение зелья опыта в Опыт Bar и на уровне героя после истечения срока
          действия
        </li>
        <li>Исправлена генерация мобов в Пещеры и отслеживание занятых клеток</li>
        <li>
          Исправлено отсутствие обработки событий движения, смерти и появления мобов в Пещеры, когда
          вкладка браузера неактивна
        </li>
        <li>Исправлена обработка отсутствующих данных о забегах в Пещеры</li>
        <li>Исправлены операции в Пещеры во время путешествия и возвращения на поверхность</li>
      </ul>

      <div class="font-bold mt-2">Улучшения качества жизни</div>
      <ul class="ml-4 list-disc">
        <li>Добавлена группировка сообщений о вдохновении в боевом логе Пещеры</li>
        <li>Добавлена группировка событий исцеления в боевом логе Пещеры</li>
      </ul>
    </div>
  </div>
</template>
